import * as React from 'react';
import { useSelector } from 'react-redux';

import { EmptyPageContainer } from '../EmptyPage';
import { Main } from '../../components/Main';
import { TableContainer } from '../Table';
import { selectComparePageType, selectIsCompareEmpty, selectIsDesktop } from '../../selectors/page';
import { MobilePageContainer } from '../MobilePage';
import { PageTitleContainer } from '../PageTitle';
import { ControlsContainer } from '../Controls';
import { PageLoaderContainer } from '../PageLoader';
import { CompareHubPageContainer } from '../CompareHubPage';
import { NewbuildingsComparePageContainer } from '../NewbuildingsComparePage';
import { NewbuildingsCompareMobilePageContainer } from '../NewbuildingsCompareMobilePage';

export const PageContainer: React.FC = () => {
  const comparePageType = useSelector(selectComparePageType);
  const isEmpty = useSelector(selectIsCompareEmpty);
  const isDesktop = useSelector(selectIsDesktop);

  if (!isDesktop) {
    // На мобильных/планшетных устройствах доступно только сравнение по ЖК (под тоглом
    // Newbuilding.CompareMobile.Enabled сервер выставляет comparePageType='newbuildings').
    if (comparePageType === 'newbuildings') {
      return <NewbuildingsCompareMobilePageContainer />;
    }

    return <MobilePageContainer />;
  }

  if (comparePageType === 'hub') {
    return <CompareHubPageContainer />;
  }

  if (isEmpty) {
    return <EmptyPageContainer />;
  }

  if (comparePageType === 'newbuildings') {
    return <NewbuildingsComparePageContainer />;
  }

  return (
    <Main>
      <PageTitleContainer />
      <ControlsContainer />
      <TableContainer />
      <PageLoaderContainer />
    </Main>
  );
};
